/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from 'zod';
import { accountSchema } from './account-schema';
import { languageSchema } from './language-schema';
import { opportunitySchema } from './opportunity-schema';
import { EstimatedDuration, FocusArea, Industry, LegalTeamSize, LevelOfExperience, LicensedLawyer, LocationAddressComponentType, StateCode, Urgency } from "../enums";
export const digitalIntakeDetailSchema: z.AnyZodObject = z.object({
  account: z.lazy(() => accountSchema).nullish(),
  accountId: z.string().uuid(),
  additionalDetailsForTalent: z.string().nullish(),
  companyLocation: 
    z.object({
      locationAddressComponents: 
        z.object({
          addresses: 
            z.array(
              z.object({
                long_name: z.string().nullish(),
                short_name: z.string().nullish(),
                types: 
                  z.array(z.nativeEnum(LocationAddressComponentType))
                .nullish(),
              })
            )
          .nullish(),
        })
      .nullish(),
      locationLatitude: z.number().nullish(),
      locationLongitude: z.number().nullish(),
      locationName: z.string().nullish(),
      locationPlaceId: z.string().nullish(),
    })
  .nullish(),
  createdAt: z.string().datetime().nullish(),
  dsSuggestedId: z.string().uuid().nullish(),
  estimatedDuration: z.nativeEnum(EstimatedDuration).nullish(),
  generalSkills: z.array(z.string()).nullish(),
  id: z.string().uuid(),
  industry: z.nativeEnum(Industry).nullish(),
  instantMatchesRefreshedAt: z.string().datetime().nullish(),
  language: z.lazy(() => languageSchema).nullish(),
  languageId: z.string().uuid().nullish(),
  legalSkills: z.array(z.string()).nullish(),
  legalTeamSize: z.nativeEnum(LegalTeamSize).nullish(),
  legalTechSkills: z.array(z.string()).nullish(),
  levelOfExperience: z.nativeEnum(LevelOfExperience).nullish(),
  licensedLawyer: z.nativeEnum(LicensedLawyer).nullish(),
  licensedLawyerState: z.nativeEnum(StateCode).nullish(),
  opportunity: z.lazy(() => opportunitySchema).nullish(),
  opportunityId: z.string().uuid().nullish(),
  otherFocusAreas: z.array(z.string()).nullish(),
  primaryFocusArea: z.nativeEnum(FocusArea).nullish(),
  startDate: z.string().date().nullish(),
  updatedAt: z.string().datetime().nullish(),
  urgency: z.nativeEnum(Urgency).nullish(),
});

export type DigitalIntakeDetail = z.infer<typeof digitalIntakeDetailSchema>;
